import type { AccordionDesignTokens, AccordionTokenSections } from '@openng/optimus-ui-themes/types/accordion';

export const panel: AccordionTokenSections.Panel = {
	borderWidth: '0',
	borderColor: 'transparent',
};

export const header: AccordionTokenSections.Header = {
	color: '{neutral.white}',
	hoverColor: '{neutral.white}',
	activeColor: '{neutral.white}',
	activeHoverColor: '{neutral.white}',
	borderRadius: '{content.border.radius}',
	background: '{surface.500}',
	hoverBackground: '{surface.800}',
	activeBackground: '{surface.800}',
	activeHoverBackground: '{surface.800}',
	focusRing: {
		offset: '{focus.ring.offset}',
	},
	toggleIcon: {
		color: '{neutral.white}',
		hoverColor: '{neutral.white}',
		activeColor: '{neutral.white}',
		activeHoverColor: '{neutral.white}',
	},
	last: {
		activeBottomBorderRadius: '{content.border.radius}',
	},
};

export default {
	panel,
	header,
} satisfies AccordionDesignTokens;
